import { Component, inject } from '@angular/core';
import { COMPANY_PROFILE_CARD_DATA_TOKEN } from '../../../tokens-and-interfaces';
import { ContactAssociationPanelComponent } from '../contact-associations-panel/contact-association-panel.component';

@Component({
  selector: 'crm-company-to-contact-associations-card',
  imports: [ContactAssociationPanelComponent],
  templateUrl: './company-to-contact-associations-card.component.html',
  styleUrls: ['../../../shared-styles/association-panel-shared.scss'],
})
export class CompanyToContactAssociationsCardComponent {
  data = inject(COMPANY_PROFILE_CARD_DATA_TOKEN);
  protected readonly id = this.data.company_id;
  protected readonly name = this.data.name;
}
